import {
  mapStructureByCompType,
  mapStructureById,
  replaceTextMarqeeImage,
  replaceVectorArt,
} from '../utils';
import {
  isFieldContentRole,
  PresetContentFieldRole,
} from '@wix/editor-content-injector';

import type {
  KitDefinition,
  KitPresetStructures,
  KitVectorArtDefinition,
} from '../types';
import type {
  FieldContentRole,
  SerializedCompStructure,
} from '@wix/document-services-types';

export const setSectionsStickers = (
  sectionsStructures: KitPresetStructures[],
  kitStickers: KitDefinition['stickers'],
): void => {
  if (!kitStickers?.length) return;
  let stickerIndex = 0;
  const processStructures = (
    structures: SerializedCompStructure[] | undefined,
    replaceFunction: (
      structure: SerializedCompStructure,
      sticker: KitVectorArtDefinition,
    ) => void,
    mobileStructureById: Record<string, SerializedCompStructure>,
  ) => {
    structures?.forEach((vectorArtStructure) => {
      const { id, contentRole } = vectorArtStructure;
      if (
        id &&
        contentRole &&
        isFieldContentRole(contentRole) &&
        (contentRole as FieldContentRole).fieldRole ===
          PresetContentFieldRole.Sticker
      ) {
        const sticker = kitStickers[stickerIndex];
        replaceFunction(vectorArtStructure, sticker);
        const mobileVectorArtStructure = mobileStructureById[id];
        if (mobileVectorArtStructure) {
          replaceFunction(mobileVectorArtStructure, sticker);
        }
        stickerIndex = (stickerIndex + 1) % kitStickers.length;
      }
    });
  };

  sectionsStructures.forEach(({ structure, mobileStructure }) => {
    const mobileStructureById = mapStructureById(mobileStructure);
    const structureByCompTypeEntry = mapStructureByCompType(structure);

    processStructures(
      structureByCompTypeEntry['wysiwyg.viewer.components.VectorImage'],
      replaceVectorArt,
      mobileStructureById,
    );

    processStructures(
      structureByCompTypeEntry['wixui.TextMarquee'],
      replaceTextMarqeeImage,
      mobileStructureById,
    );
  });
};
